import type { Option } from "@tento-lona/sheets";
import { NaiveDate } from "@tento-chrono";
import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css, Style } from "@tento-ui/component-styles";
import { $$ } from "@tento-ui/fastdom";

@component({
  name: "std-header-legend",
})
export class HeaderLegend extends LonaWebComponent {
  #$$ = {
    timeLabel: this.$("time-label"),
    monthTitle: this.$("month-title"),
    yearTitle: this.$("year-title"),
  };

  bind(nd: Option<NaiveDate>) {
    $$.mutate(() => {
      if (!nd) {
        this.#$$.monthTitle.textContent = "";
        this.#$$.yearTitle.textContent = "";
      } else {
        this.#$$.monthTitle.textContent = nd.month.name;
        this.#$$.yearTitle.textContent = String(nd.yr);
      }
    });
  }

  static $styles: Style.Compat[] = [
    css`
      #time-label {
        margin-top: 6px;
        padding-top: 6px;
        margin-left: 4px;
      }

      #month-title {
        font-weight: 500;
      }

      #year-title {
        font-weight: 300;
        color: var(--text-ter);
      }

      #title {
        white-space: nowrap;
        padding-right: 8px;
      }
    `,
  ];

  static $html: Option<HTMLTemplateElement> = html`
    <std-row id="time-label">
      <h1 class="h6" id="title">
        <span id="month-title"></span>
        <span id="year-title"></span>
      </h1>
    </std-row>
  `;
}
